import { render, staticRenderFns } from "./LocationPermissionItem.vue?vue&type=template&id=5ae2a802&"
import script from "./LocationPermissionItem.vue?vue&type=script&lang=js&"
export * from "./LocationPermissionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports